import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLightBulb = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14.889,
	height: 14,
	viewBox: "0 0 14.889 14",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a,.b{fill:none;}.a{stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;}" }) }),
		/* @__PURE__ */ _jsxs("g", {
			transform: "translate(0.813 1.639)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M12.722,15.19H9",
					transform: "translate(-4.229 -7.968)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M7.576,10.356a3.408,3.408,0,0,1-1.53-3.417A3.645,3.645,0,0,1,9.272,4.025,3.647,3.647,0,0,1,13.444,7.5a3.436,3.436,0,0,1-1.578,2.857.593.593,0,0,0-.284.487v1.614a1.507,1.507,0,0,1-1.551,1.458h-.62a1.507,1.507,0,0,1-1.551-1.458V10.847A.6.6,0,0,0,7.576,10.356Z",
					transform: "translate(-3.09 -3.306)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M20,4.5l.738-.694",
					transform: "translate(-8.405 -3.227)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M3.548,15l-.738.694",
					transform: "translate(-1.879 -7.889)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M4.548,3.5,3.81,2.81",
					transform: "translate(-2.259 -2.81)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M20,15l.738.694",
					transform: "translate(-8.405 -7.889)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M21,10h1.048",
					transform: "translate(-8.785 -5.806)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M1.31,10H2.358",
					transform: "translate(-1.31 -5.806)"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "a",
					d: "M9,18h3.642",
					transform: "translate(-4.229 -9.139)"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M0,0H14.889V14H0Z"
		})
	]
});
export default SvgLightBulb;
